import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const usePortalContext = () => {
  const page = usePage()

  const pageComponent = computed(() => page.component ?? '')
  const isBankAuthPage = computed(() => pageComponent.value.startsWith('auth/banker/'))
  const isBankAppPage = computed(() => pageComponent.value.startsWith('banks/'))
  const isBankPortal = computed(() => isBankAuthPage.value || isBankAppPage.value)
  const portal = computed<'banker' | 'investor'>(() => (isBankPortal.value ? 'banker' : 'investor'))

  return {
    isBankAppPage,
    isBankAuthPage,
    isBankPortal,
    pageComponent,
    portal,
  }
}

export { usePortalContext }
